var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24797 15.1661C4.29463 15.1661 1.0813 11.9528 1.0813 7.99948C1.0813 4.04614 4.29463 0.832809 8.24797 0.832809C12.2013 0.832809 15.4146 4.04614 15.4146 7.99948C15.4146 11.9528 12.2013 15.1661 8.24797 15.1661ZM8.24797 1.83281C4.84797 1.83281 2.0813 4.59948 2.0813 7.99948C2.0813 11.3995 4.84797 14.1661 8.24797 14.1661C11.648 14.1661 14.4146 11.3995 14.4146 7.99948C14.4146 4.59948 11.648 1.83281 8.24797 1.83281Z",
    fill: "#00BF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36088 10.3857C6.23422 10.3857 6.10755 10.3391 6.00755 10.2391C5.81422 10.0457 5.81422 9.72573 6.00755 9.53239L9.78088 5.75906C9.97422 5.56573 10.2942 5.56573 10.4875 5.75906C10.6809 5.95239 10.6809 6.27239 10.4875 6.46573L6.71422 10.2391C6.62088 10.3391 6.48755 10.3857 6.36088 10.3857Z",
    fill: "#00BF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1342 10.3857C10.0075 10.3857 9.88088 10.3391 9.78088 10.2391L6.00755 6.46573C5.81422 6.27239 5.81422 5.95239 6.00755 5.75906C6.20088 5.56573 6.52088 5.56573 6.71422 5.75906L10.4875 9.53239C10.6809 9.72573 10.6809 10.0457 10.4875 10.2391C10.3875 10.3391 10.2609 10.3857 10.1342 10.3857Z",
    fill: "#00BF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleActive);
export default __webpack_public_path__ + "static/media/close-circle_active.83a2f1d1f7597d66df647fe9d3feed61.svg";
export { ForwardRef as ReactComponent };